import { FC, useCallback } from "react";
import { Footer, FooterProps } from "./footer";
import { useWebgate } from "@xvia/webgate-connect";

export const FooterContainer: FC = () => {
  const portalUrl = process.env.PORTAL_URL || "https://dev.pidigital.pi.gov.br";

  const { portalConnect, userInfo } = useWebgate();

  const onClickLogin = useCallback(() => {
    portalConnect?.login({
      redirectUri: `${process.env.PORTAL_URL}`,
    });
  }, [portalConnect]);

  const props: FooterProps = {
    social: [
      {
        icon: "fa-facebook-f",
        link: "https://pt-br.facebook.com/governodopiaui/",
        ariaLabel: "Acesse a página do Governo do Piauí no Facebook",
      },
      {
        icon: "fa-twitter",
        link: "https://twitter.com/GovernodoPi",
        ariaLabel: "Acesse a página do Governo do Piauí no Twitter",
      },
      {
        icon: "fa-instagram",
        link: "https://instagram.com/governodopiaui",
        ariaLabel: "Acesse a página do Governo do Piauí no Instagram",
      },
      {
        icon: "fa-youtube",
        link: "https://www.youtube.com/channel/UCUvn6mz9Su40_xqyZjK5Onw",
        ariaLabel: "Acesse o canal do Governo do Piauí no YouTube",
      },
    ],
    lists: [
      {
        title: "Governo",
        linkList: [
          {
            text: "Site Institucional do Governo do Piauí",
            link: "https://www.pi.gov.br/",
          },
          {
            text: "Agenda do Governador",
            link: "https://www.pi.gov.br/agenda/",
          },
          {
            text: "Ações e Programas do Governo",
            link: "https://www.pi.gov.br/",
          },
          {
            text: "Catálogo de Dados Abertos",
            link: "/app/catalog/dados",
          },
          {
            text: "Órgãos do Governo",
            link: "/app/catalog/orgao",
          },
        ],
      },
      {
        title: "Soluções Gov.pi",
        linkList: [
          {
            text: "Gov.pi Proativo",
            link: `${portalUrl}/app/app-governo-proativo`,
          },
          ...(!userInfo
            ? [
                {
                  text: "Criar conta no Gov.Pi",
                  callback: onClickLogin,
                },
              ]
            : []),
          {
            text: "Gov.pi Conecta",
            link: "https://govpiconecta.pi.gov.br/",
          },
          {
            text: "Ciências de dados e IA",
            link: "https://gcdi.pi.gov.br/",
          },
          {
            text: "Canais Atendimento",
            link: `${portalUrl}/app/app-canais-atendimento`,
          },
        ],
      },
      {
        title: "Links úteis",
        linkList: [
          {
            text: "Estratégia Digital do Governo do Piauí",
            link: "http://www.egd.pi.gov.br",
          },
          {
            text: "Política de Privacidade e Termos de Uso",
            link: `${portalUrl}/app/politicas-de-privacidade-termo-de-uso`,
          },
          {
            text: "Portal da Transparência do Piauí",
            link: "https://transparencia.pi.gov.br",
          },
          {
            text: "Indicadores de Transformação Digital",
            link: "https://dados-abertos.etipi.pi.gov.br/dashboard",
          },
          {
            text: "Meios de Pagamentos Digitais do Governo do Piauí",
            link: `${portalUrl}/app/meios-pagamentos`,
          },
        ],
      },
      {
        title: "Suporte Gov.pi",
        linkList: [
          {
            icon: "phone",
            text: "(86) 98878-8533",
          },
          {
            icon: "mail",
            text: "suporte.govpi@etipi.pi.gov.br",
          },
        ],
      },
    ],
    contact: "  Contato: (86) 3326-2001  ",
    ramal: "  162",
    email: "  ouvidoria@etipi.gov.br",
    address:
      "Endereço: Av. Antonino Freire, 1450<br/>Centro (Sul)<br/>Teresina - PI, 64001-040",
  };

  return <Footer {...props} />;
};
